import React from 'react';

function getWrapSize(size) {
    switch (size) {
        case 'large':
            return 'max-w-screen-2xl';
        case 'small':
            return 'max-w-screen-lg';
        default:
            return 'max-w-screen-xl';
    }
}
const Wrap = React.forwardRef(({ center = true, children, className = '', size = 'large', spacer = true, tagName = 'section', ...props }, ref) => {
    const Component = tagName;
    return (React.createElement(Component, { ref: ref, className: [
            'w-full px-5 lg:px-10 grid gap-y-10 lg:gap-y-12',
            center ? 'mx-auto' : '',
            spacer ? 'py-12 md:py-16' : '',
            getWrapSize(size),
            className,
        ].join(' '), ...props }, children));
});

export { Wrap };
//# sourceMappingURL=Wrap.js.map
